import { useRef } from 'react';
import ReportAPI from 'api/report.api';
import MaterialMovementReportBase from './MaterialMovementReportBase';

const MaterialMovementByDump = () => {
  const reportApi = useRef(new ReportAPI()).current;

  return (
    <MaterialMovementReportBase
      titleKey="material_movement_by_dump_title"
      primaryField="unloading_area"
      csvFilenamePrefix="material-movement-by-dump"
      fetchReport={reportApi.getMaterialMovementByDump}
    />
  );
};

export default MaterialMovementByDump;
